// @flow
export const CRUDABLE_ADMIN_RESOURCES = [
  'page',
];